module.exports = __webpack_public_path__ + "img/trigger-green.8b985ae1.svg";